<template lang="pug">
  .component-create-packet-vehicle-category-modal
    ModalReveal(ref="packetCategoryModal" :key="key" @input="closeInput")
      slot(slot ="trigger")
        a.fa-stack.fa-lg
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
      .body
        h2 Assign packet to category
        .row(v-if="packetCategory")
          .columns.large-4
            label Packet Vehicle Category id:
            input(type='text' disabled="disabled" :value = "packetCategory.id")
          .columns.large-4
              label Packet id:
              input(type='text' disabled="disabled" :value = "selectedPacket")
        .row
          .columns.large-4(v-if="!packetCategory")
            SelectizePacket(@optionSelected="selectPacket")
          .columns.large-4
            SelectizeCategory(@optionSelected="selectCategory" :selectedValue="selectedCategory")
      .row.columns(slot="footer")
        ActionButton(:action="save") Save

</template>

<script>
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";
import ModalReveal from "../../../foundation/ModalReveal";
import SelectizeCategory from "../../lists/selectize/SelectizeCategory";
import SelectizePacket from "../../lists/selectize/SelectizePacket";
import ActionButton from "../../ActionButton";
import InlineEditableField from "../../InlineEditableField";
export default {
  name: "PacketVehicleCategoryModal",
  components: {InlineEditableField, SelectizePacket, SelectizeCategory, ModalReveal, ActionButton},
  data() {
    return {
      body: {
        vehicle_category_id: null,
        packet_id: null
      },
      key:0,
      selectedCategory: null,
      selectedPacket: null,
    }
  },
  created() {
    if (this.packetCategory) {
      Object.assign(this.body, this.packetCategory)
      this.selectedCategory = this.packetCategory.category.id
      this.selectedPacket = this.packetCategory.packet.id
      this.body.packet_id = this.selectedPacket
    }
  },
  methods: {
    closeInput(event) {
      if(!event) {
        this.key++
      }
    },
    selectCategory(item) {
       this.body.vehicle_category_id = item.id
    },
    selectPacket(item) {
      this.body.packet_id = item.id
    },
    save(){
      if(this.packetCategory) {
        return this.edit()
      }
      return KeplerBackofficeSdk.packetVehicleCategories.make(this.body, (data) => {
        if(data && typeof data.id === "number") {
          MaggieHelper.notification('Packet vehicle category added', 'id: ' + data.id)
          this.$emit('itemUpdated','added')
         }
          else {
          MaggieHelper.notification('esit: ',  data.result_code)
        }
        this.body = {
          vehicle_category_id: null,
          packet_id: null
        }

        this.$refs.packetCategoryModal.close()
      })
    },
    edit() {
      return KeplerBackofficeSdk.packetVehicleCategories.select(this.body).edit(this.body, (data) => {
        if(data && typeof data.id === "number") {
        MaggieHelper.notification('Updated packet vehicle category ', 'id:' + data.id)
          this.$emit('itemUpdated','added')
        }
        else {
          MaggieHelper.notification('esit: ',  data.result_code)
        }

        this.key++
        this.$refs.packetCategoryModal.close()
      })
    }
  },
  props:['packetCategory']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketVehicleCategoryModal.vue?4ea79950